import { ItemID } from "types/common";

import { defaultTimeToLive } from "consts";

import { useGetItemCodes } from "./useGetItemCodes";

export const useGetItemCodesWithCache = (itemID: ItemID) => {
  return useGetItemCodes(itemID, defaultTimeToLive);
}
